// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field } from 'redux-form'
import { CheckboxGroup } from 'components/Form'
import { handleExportTypesChange } from './helpers'

class ExportTypes extends React.Component {
  static propTypes = {
    handleExportTypesChange: func.isRequired,
    idRoot: string.isRequired,
  }

  options = [{
    label: 'Datasheet (.docx)',
    value: 'docx',
  }, {
    label: 'Datasheet (.pdf)',
    value: 'pdf',
  }, {
    label: 'Spreadsheet (.csv)',
    value: 'csv',
  }, {
    label: 'KML (.kml)',
    value: 'kml',
  }]

  render () {
    const {
      handleExportTypesChange,
      idRoot,
    } = this.props

    return (
      <Field
        checkBoxClasses={'padding-top-half display-flex flex-direction-column'}
        component={CheckboxGroup}
        idRoot={idRoot}
        name={'pathExportTypes'}
        onChangeCustom={handleExportTypesChange}
        options={this.options} />
    )
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    handleExportTypesChange,
  }, dispatch)
)

export default connect(
  () => ({}),
  mapDispatchToProps
)(ExportTypes)
